import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Additional Codes ")
const _hoisted_44 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_46 = { class: "font-bold" }
const _hoisted_47 = { class: "font-bold text-light text-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_info_field = _resolveComponent("info-field")!
  const _component_section_wrapper = _resolveComponent("section-wrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_spinner, {
          key: 0,
          class: "mx-auto"
        }))
      : _createCommentVNode("", true),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_section_wrapper, { class: "bg-white" }, {
            default: _withCtx(() => [
              _createVNode(_component_info_field, {
                class: "mb-5 md:w-1/2",
                label: "parcels.details.hub"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.parcel.hub), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_info_field, {
                class: "mb-5 md:w-1/2",
                label: "parcels.details.tracking_number"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: "font-bold text-primary-blue cursor-pointer",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openTrackingUrl(_ctx.parcel.tracking_url)), ["prevent"]))
                  }, _toDisplayString(_ctx.parcel?.tracking_number || "-"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_info_field, {
                class: "mb-5 md:w-1/2",
                label: "parcels.details.supplier_system_number"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.parcel?.supplier_system_number || "-"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_info_field, {
                class: "mb-5 md:w-1/2",
                label: "parcels.details.supplier_order_name"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.parcel?.supplier_order_number || "-"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_info_field, {
                class: "mb-5 md:w-1/2",
                label: "parcels.details.shipper_reference"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.parcel?.shipper_reference || "-"), 1)
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parcel.references, (item) => {
                return (_openBlock(), _createBlock(_component_info_field, {
                  key: item.key,
                  class: "mb-5 md:w-1/2",
                  label: item.key
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.value || "-"), 1)
                  ]),
                  _: 2
                }, 1032, ["label"]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_section_wrapper, { class: "bg-white" }, {
            default: _withCtx(() => [
              _createVNode(_component_info_field, {
                class: "mb-5 md:w-1/2",
                label: "parcels.details.receiver"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(_ctx.parcel?.receiver_address?.name || "-") + " ", 1),
                    _hoisted_2,
                    _createTextVNode(" " + _toDisplayString(_ctx.parcel?.receiver_address?.company_name || "-") + " ", 1),
                    _hoisted_3,
                    _createTextVNode(" " + _toDisplayString(_ctx.parcel?.receiver_address?.address_first_line || "-") + " ", 1),
                    _hoisted_4,
                    (_ctx.parcel?.receiver_address?.address_second_line)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.parcel?.receiver_address?.address_second_line || "-") + " ", 1),
                          _hoisted_5
                        ], 64))
                      : _createCommentVNode("", true),
                    _hoisted_6,
                    _hoisted_7,
                    _createTextVNode(" " + _toDisplayString(`${_ctx.parcel?.receiver_address?.city ?? ""} ${
              _ctx.parcel?.receiver_address?.zip_code ?? ""
            }`.trim() || "-") + " ", 1),
                    _hoisted_8,
                    _createTextVNode(" " + _toDisplayString(_ctx.parcel?.receiver_address?.state || "-") + " ", 1),
                    _hoisted_9,
                    _createTextVNode(" " + _toDisplayString(_ctx.parcel?.receiver_address?.country.name || "-") + " ", 1),
                    _hoisted_10,
                    _createTextVNode(" " + _toDisplayString(_ctx.parcel?.receiver_address?.phone || "-") + " ", 1),
                    _hoisted_11,
                    _createTextVNode(" " + _toDisplayString(_ctx.parcel?.receiver_address?.email || "-") + " ", 1),
                    _hoisted_12
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_info_field, {
                class: "mb-5 md:w-1/2",
                label: "parcels.details.shipper"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(_ctx.parcel?.shipper_address?.name || "-") + " ", 1),
                    _hoisted_13,
                    _createTextVNode(" " + _toDisplayString(_ctx.parcel?.shipper_address?.company_name || "-") + " ", 1),
                    _hoisted_14,
                    _createTextVNode(" " + _toDisplayString(_ctx.parcel?.shipper_address?.address_first_line || "-") + " ", 1),
                    _hoisted_15,
                    (_ctx.parcel?.shipper_address?.address_second_line)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.parcel?.shipper_address?.address_second_line || "-") + " ", 1),
                          _hoisted_16
                        ], 64))
                      : _createCommentVNode("", true),
                    _hoisted_17,
                    _hoisted_18,
                    _createTextVNode(" " + _toDisplayString(`${_ctx.parcel?.shipper_address?.city ?? ""} ${
              _ctx.parcel?.shipper_address?.zip_code ?? ""
            }`.trim() || "-") + " ", 1),
                    _hoisted_19,
                    _createTextVNode(" " + _toDisplayString(_ctx.parcel?.shipper_address?.state || "-") + " ", 1),
                    _hoisted_20,
                    _createTextVNode(" " + _toDisplayString(_ctx.parcel?.shipper_address?.country?.name || "-") + " ", 1),
                    _hoisted_21,
                    _createTextVNode(" " + _toDisplayString(_ctx.parcel?.shipper_address?.phone || "-") + " ", 1),
                    _hoisted_22,
                    _createTextVNode(" " + _toDisplayString(_ctx.parcel?.shipper_address?.email || "-") + " ", 1),
                    _hoisted_23
                  ])
                ]),
                _: 1
              }),
              (_ctx.parcel?.pickup_point_address)
                ? (_openBlock(), _createBlock(_component_info_field, {
                    key: 0,
                    class: "mb-5 md:w-1/2",
                    label: "parcels.details.pickup_point"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createTextVNode(" Code: " + _toDisplayString(_ctx.parcel?.pickup_point_id || "-") + " ", 1),
                        _hoisted_24,
                        _createTextVNode(" " + _toDisplayString(_ctx.parcel?.pickup_point_address?.name || "-") + " ", 1),
                        _hoisted_25,
                        _createTextVNode(" " + _toDisplayString(_ctx.parcel?.pickup_point_address?.company_name || "-") + " ", 1),
                        _hoisted_26,
                        _createTextVNode(" " + _toDisplayString(_ctx.parcel?.pickup_point_address?.address_first_line || "-") + " ", 1),
                        _hoisted_27,
                        (_ctx.parcel?.pickup_point_address?.address_second_line)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.parcel?.pickup_point_address?.address_second_line || "-") + " ", 1),
                              _hoisted_28
                            ], 64))
                          : _createCommentVNode("", true),
                        _hoisted_29,
                        _hoisted_30,
                        _createTextVNode(" " + _toDisplayString(`${_ctx.parcel?.pickup_point_address?.city ?? ""} ${
              _ctx.parcel?.pickup_point_address?.zip_code ?? ""
            }`.trim() || "-") + " ", 1),
                        _hoisted_31,
                        _createTextVNode(" " + _toDisplayString(_ctx.parcel?.pickup_point_address?.state || "-") + " ", 1),
                        _hoisted_32,
                        _createTextVNode(" " + _toDisplayString(_ctx.parcel?.pickup_point_address?.country?.name || "-") + " ", 1),
                        _hoisted_33,
                        _createTextVNode(" " + _toDisplayString(_ctx.parcel?.pickup_point_address?.phone || "-") + " ", 1),
                        _hoisted_34,
                        _createTextVNode(" " + _toDisplayString(_ctx.parcel?.pickup_point_address?.email || "-") + " ", 1),
                        _hoisted_35
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.parcel?.pickup_point_address?.pickup_point)
                ? (_openBlock(), _createBlock(_component_info_field, {
                    key: 1,
                    class: "mb-5 md:w-1/2",
                    label: "parcels.details.pickup_point_data"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createTextVNode(" Description: " + _toDisplayString(_ctx.parcel?.pickup_point_address?.pickup_point?.description || "-") + " ", 1),
                        _hoisted_36,
                        _createTextVNode(" PUDO Owner: " + _toDisplayString(_ctx.parcel?.pickup_point_address?.pickup_point?.owner_party || "-") + " ", 1),
                        _hoisted_37,
                        _createTextVNode(" Distance: " + _toDisplayString(new Intl.NumberFormat("en-US").format(
              _ctx.parcel?.pickup_point_address?.pickup_point?.distance
            ) || "-") + " ", 1),
                        _hoisted_38,
                        _createTextVNode(" Latitude: " + _toDisplayString(_ctx.parcel?.pickup_point_address?.pickup_point?.latitude || "-") + " ", 1),
                        _hoisted_39,
                        _createTextVNode(" Longitude: " + _toDisplayString(_ctx.parcel?.pickup_point_address?.pickup_point?.longitude || "-") + " ", 1),
                        _hoisted_40,
                        _createTextVNode(" Metadata: " + _toDisplayString(_ctx.parcel?.pickup_point_address?.pickup_point?.metadata || "-") + " ", 1),
                        _hoisted_41
                      ]),
                      _hoisted_42,
                      _hoisted_43,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parcel?.pickup_point_address?.pickup_point
            ?.additional_codes, (item, key) => {
                        return (_openBlock(), _createElementBlock("p", { key: key }, [
                          _createTextVNode(_toDisplayString(key) + ": " + _toDisplayString(item) + " ", 1),
                          _hoisted_44
                        ]))
                      }), 128)),
                      _hoisted_45
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_section_wrapper, { class: "bg-white" }, {
            default: _withCtx(() => [
              _createVNode(_component_info_field, {
                class: "mb-5 md:w-1/2",
                label: "parcels.details.supplier"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.parcel?.supplier?.full_name || "-"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_info_field, {
                class: "mb-5 md:w-1/2",
                label: "parcels.details.product"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.parcel?.product?.name || "-"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_info_field, {
                class: "mb-5 md:w-1/2",
                label: "parcels.details.integration_source"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.parcel?.integration_source_name || "-"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_info_field, {
                class: "mb-5 md:w-1/2",
                label: "parcels.details.owner_id"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.parcel?.owner_id || "-"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_info_field, {
                class: "mb-5 md:w-1/2",
                label: "parcels.details.owner"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.parcel?.owner_name || "-"), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_section_wrapper, { class: "bg-white" }, {
            default: _withCtx(() => [
              _createVNode(_component_info_field, {
                class: "mb-5 md:w-1/2",
                label: "parcels.details.weight"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("parcels.details.weight_value", { weight: _ctx.parcel?.weight })), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_info_field, {
                class: "mb-5 md:w-1/2",
                label: "parcels.details.value"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(`${_ctx.parcel?.price_value ?? ""} ${
            _ctx.parcel?.price_currency ?? ""
          }`.trim() || "-"), 1)
                ]),
                _: 1
              }),
              (_ctx.parcel?.insurance)
                ? (_openBlock(), _createBlock(_component_info_field, {
                    key: 0,
                    class: "mb-5 md:w-1/2",
                    label: "parcels.details.extra_cover"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("parcels.details.extra_cover_value", {
            amount: _ctx.parcel.insurance.amount,
            currency: _ctx.parcel.insurance.currency,
            description: _ctx.parcel.insurance.description,
            code: _ctx.parcel.insurance.product_code,
          })), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_info_field, {
                class: "mb-5 md:w-1/2",
                label: "parcels.details.dimensions"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("parcels.details.dimensions_value", {
            length: _ctx.parcel.length,
            width: _ctx.parcel.width,
            height: _ctx.parcel.height,
          })), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.parcel?.products && !!_ctx.parcel?.products?.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_section_wrapper, { class: "bg-white" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.$t("parcels.details.products")), 1)
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parcel?.products, (product, index) => {
                  return (_openBlock(), _createBlock(_component_section_wrapper, {
                    class: "bg-white",
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_info_field, {
                        class: "mb-5 md:w-1/2",
                        label: "parcels.details.product_description"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(product?.description || "-"), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_info_field, {
                        class: "mb-5 md:w-1/2",
                        label: "parcels.details.country"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(product?.country_name || "-"), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_info_field, {
                        class: "mb-5 md:w-1/2",
                        label: "parcels.details.sku"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(product?.sku || "-"), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_info_field, {
                        class: "mb-5 md:w-1/2",
                        label: "parcels.details.purchase_web_address"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(product?.purchase_web_address || "-"), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_info_field, {
                        class: "mb-5 md:w-1/2",
                        label: "parcels.details.hs_code"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(product?.hs_code || "-"), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_info_field, {
                        class: "mb-5 md:w-1/2",
                        label: "parcels.details.item_composition"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(product?.item_composition || "-"), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_info_field, {
                        class: "mb-5 md:w-1/2",
                        label: "parcels.details.quantity"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(product?.quantity || "-"), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_info_field, {
                        class: "mb-5 md:w-1/2",
                        label: "parcels.details.cpc_code"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(product?.cpc_code || "-"), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_info_field, {
                        class: "mb-5 md:w-1/2",
                        label: "parcels.details.value"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(`${product?.price_value ?? ""} ${
              product?.price_currency ?? ""
            }`.trim() || "-"), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_info_field, {
                        class: "mb-5 md:w-1/2",
                        label: "parcels.details.warehouse_number"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(product?.warehouse_number || "-"), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}